/* Phase 7 — collision disambiguation prompt. Visual structure mirrors
 * the Android `CollisionDisambiguationStep` Composable: heading +
 * subhead, a row of chip suggestions, a custom-name input, a primary
 * Save button, and a tertiary "Use the original name anyway" text
 * link.
 */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
  padding: var(--spacing-16);
  background: var(--bg-primary);
  color: var(--text-primary);
}

.title {
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
}

.subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-secondary);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-8);
}

.chip {
  font: inherit;
  font-size: 13px;
  line-height: 18px;
  padding: 6px 12px;
  border-radius: 16px;
  border: 1px solid var(--button-outline-stroke);
  background: var(--bg-primary);
  color: var(--text-primary);
  cursor: pointer;
}

.chip[data-selected="true"] {
  background: var(--button-primary);
  border-color: var(--button-primary);
  color: var(--text-on-dark);
}

.chip:hover:not(:disabled) {
  background: var(--button-outline-bg-hover);
}

.chip[data-selected="true"]:hover:not(:disabled) {
  background: var(--button-primary);
  filter: brightness(0.95);
}

.chip:focus-visible {
  outline: 2px solid var(--button-primary);
  outline-offset: 2px;
}

.customLabel {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: var(--text-secondary);
}

.customInput {
  font: inherit;
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid var(--button-outline-stroke);
  background: var(--bg-primary);
  color: var(--text-primary);
}

.errorMessage {
  font-size: 13px;
  color: var(--text-negative);
  text-align: center;
}

.useAnywayLink {
  font: inherit;
  font-size: 13px;
  background: none;
  border: none;
  color: var(--text-link);
  cursor: pointer;
  text-align: center;
  padding: 4px;
}

.useAnywayLink:focus-visible {
  outline: 2px solid var(--button-primary);
  outline-offset: 2px;
  border-radius: 4px;
}
